import { addProps, SimplePropsAdder } from 'ad-hok'
import { throttle } from 'lodash/fp'
import { useEffect, useMemo, useState } from 'react'

interface ScrollPosition {
  x: number
  y: number
}

const getWindowScrollPosition = (): ScrollPosition => ({
  x: window.scrollX,
  y: window.scrollY,
})

const useWindowScrollPositionThrottled = (
  throttleMilliseconds = 50
): ScrollPosition => {
  const scrollPositionOnMount = useMemo(getWindowScrollPosition, [])
  const [scrollPosition, setScrollPosition] = useState(scrollPositionOnMount)

  const callback = useMemo(
    () =>
      throttle(throttleMilliseconds, () => {
        setScrollPosition(getWindowScrollPosition)
      }),
    [throttleMilliseconds, setScrollPosition]
  )

  useEffect(() => {
    window.addEventListener('scroll', callback)

    return () => {
      window.removeEventListener('scroll', callback)
    }
  }, [throttleMilliseconds, callback])

  return scrollPosition
}

type AddWindowScrollPositionThrottled = (
  throttleMilliseconds?: number
) => SimplePropsAdder<{
  windowScrollPositionThrottled: ScrollPosition
}>

export const addWindowScrollPositionThrottled: AddWindowScrollPositionThrottled =
  (throttleMilliseconds) =>
    addProps(() => ({
      windowScrollPositionThrottled:
        useWindowScrollPositionThrottled(throttleMilliseconds),
    }))
